<template>
  <v-col>
    <v-container fluid class="mt-5">

      <v-row class="align-center justify-center">
        <v-flex xs12>
          <v-img contain src="https://app.simulatoreclickday.it/img/inail.png" height="60"></v-img>
        </v-flex>
      </v-row>

      <v-row class="subheading mt-4 align-center justify-center">
        <b>SPORTELLO INFORMATICO PER L'INVIO DELLA DOMANDA ON LINE</b>
      </v-row>
	    
	    <!--<v-row class="subheading mt-4 align-center justify-center">-->
		  <!--  <b>SPORTELLO INFORMATICO PER L'INVIO DELLA DOMANDA VOUCHER INNOVATION MANAGER</b>-->
	    <!--</v-row>-->
	    

      <v-row v-if="alertType" class="mt-3 justify-center">
        <v-flex xs4>
          <v-alert :type="alertType" :value="true" outlined>
            <span v-html="risultatoSimulazione.message"></span>
          </v-alert>
        </v-flex>
      </v-row>
        
      <div v-else class="mt-6">
        <v-row class="subheading font-weight-bold" justify="center">
          Simulazione eseguita! Hai impiegato:
        </v-row>

        <v-row class="mt-2 title" :style="'color: ' + risultatoSimulazione.colore" justify="center">
          {{ risultatoSimulazione.tempoImpiegato }} Secondi
        </v-row>

        <v-row v-if="risultatoSimulazione.countAltriUtenti > 0" class="mt-2" justify="center">
          <span v-if="risultatoSimulazione.countAltriUtenti == 1">Un cliccatore ha fatto un tempo migliore del tuo! Ha impiegato <b>{{ risultatoSimulazione.minimoAltriUtenti }}</b> secondi</span>
          <span v-else>{{risultatoSimulazione.countAltriUtenti}} cliccatori hanno fatto un tempo migliore del tuo! Il migliore ha impiegato <b>{{ risultatoSimulazione.minimoAltriUtenti }}</b> secondi</span>
        </v-row>

        <div v-if="risultatoSimulazione.provaGratuita" class="mt-4 subheading font-weight-bold">
          <v-row justify="center">Vuoi avere il tempo preciso al millesimo e tutte le statistiche?</v-row>
          <v-row justify="center"><a href="https://simulatoreclickday.it/prezzi/" style="text-align:center; text-decoration: none;" class="error--text" target="_blank">ACQUISTA UNO DEI NOSTRI PACCHETTI!</a></v-row>
        </div>
      </div>
	    
	    <v-row v-if="risultatoSimulazione.colore == 'red'" class="mt-3 mb-8" justify="center">
        <span style="text-align: center">
          <br>
          Cavolo la simulazione non è risultata vincente!
          <br><br>
          Per far in modo di vincere la prossima scopri nella sezione <a href="/home#/gaming-consigli" target="_blank">CONSIGLI</a> i <b>segreti per migliorare</b>:<br>strategie testate, trucchi per evitare errori comuni e tecniche per gestire al meglio ogni situazione.
          <br><br>
          Abbiamo aggiunto <b>consigli nuovi</b> e aggiornato alcuni di quelli già presenti adattandoli <b>appositamente per questo bando</b>.<br>
          Non perderteli! 👉 <a class="ml-1" href="/home#/gaming-consigli" target="_blank">CONSIGLI</a>
        </span>
	    </v-row>

      <v-row class="mt-6 align-center justify-center">
        <v-btn depressed rounded @click="goBack()" :color="inailColor" class="white--text mr-6">
          Torna alla Home
        </v-btn>
        <v-btn depressed rounded @click="prossimaSimulazione()" :color="inailColor" class="white--text">
          Prossima simulazione
        </v-btn>
      </v-row>

      <v-snackbar v-model="snackbar.showSnackbar" bottom :timeout="10000" v-if="snackbar.alertType != null && snackbar.message != null" :color="(snackbar.alertType == 'warning' ? 'warning' : (snackbar.alertType != 'error' ? scdColor : 'error'))">
        {{ snackbar.message }}
        <v-btn color="white" text @click="snackbar.alertType = null">
          Chiudi
        </v-btn>
      </v-snackbar>

    </v-container>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      alertType: null,

      risultatoSimulazione: {
        // DATI IN ARRIVO DAL LOCAL STORAGE
        bandoId: null,
        provaGratuita: null,
        message: null,
        tempoImpiegato: null,
        colore: null,
        minimoAltriUtenti: null,
        countAltriUtenti: null,
      },
      // message: null,

      snackbar: {
        showSnackbar: false,
        message: null,
        alertType: null,
      }

      // tempoImpiegato: null,
      // colore: null,
      
      // minimoAltriUtenti: this.$route.params.minimoAltriUtenti,
      // countAltriUtenti: this.$route.params.countAltriUtenti,
      
    };
  },
  beforeCreate() {
    // if (_.isEmpty(this.$route.params)) { // ho usato la libreria Lodash per controllare se l'oggetto è vuoto
    //   window.location.href = "/home";
    // }
  },
  created() {
    // if (_.isEmpty(this.$route.params)) { // ho usato la libreria Lodash per controllare se l'oggetto è vuoto
    //   window.location.href = "/home";
    // }

    this.risultatoSimulazione = JSON.parse(localStorage.getItem('risultatoSimulazione'));

    if(this.risultatoSimulazione.hasError == true){
      this.alertType = "error";
      this.message = this.risultatoSimulazione.message;
    }

    this.tempoImpiegato = this.risultatoSimulazione.tempoImpiegato ;
    this.colore = this.risultatoSimulazione.colore ;

    // if(this.$route.params.hasError == true){
    //   this.alertType = "error";
    //   this.message = this.$route.params.message;
    // }

    // this.tempoImpiegato = this.$route.params.tempoImpiegato ;
    // this.colore = this.$route.params.colore ;
  },
  methods: {
    goBack: function() {
      window.location.href = "/home";
    },
    async prossimaSimulazione() {
      try {
        // Controllo se l'utente può fare simulazioni
        // let response = await axios.get('/utentePuoFareLaSimulazione');
        // const utentePuoFareLaSimulazione = response.data.utentePuoFareLaSimulazione;

        // if (!utentePuoFareLaSimulazione) {
        //   this.snackbar.alertType = "warning";
        //   this.snackbar.message = response.data.message;
        //   this.snackbar.showSnackbar = true;
        //   return
        // }

        // Ottengo id e data_ora della prossima simulazione
        let response = await axios.get('/ottieniProssimaSimulazione');
        const idSimulazione = response.data.id;
        const dataOraSimulazione = response.data.data_ora;
				const route = response.data.bando.route;
	      
	      console.log(route)
        // Controllo se ho già premuto il bottone "Prossima simulazione"
        if(this.isEnteringSimulazione) return;
        this.isEnteringSimulazione = true;

        // Controllo se ho skippato simulazioni:
        response = await axios.get(`/cliccatore/accediSimulazione/${idSimulazione}/${this.risultatoSimulazione.bandoId}/${dataOraSimulazione}`)
         
        // salvo la simulazione sul database
        axios
        .post('/salvaSimulazione', {
          id: idSimulazione,
          dataOra: dataOraSimulazione
        })
        .then(response => {
          console.log('r');
          if (response.data.hasError) {
            this.snackbar.alertType = "error";
            this.snackbar.message = response.data.message;
            this.snackbar.alertColor = 'red';
            this.snackbar.showSnackbar = true;

          } else {
            this.$router.push({ name: route });
          }
        })
        .catch(error => {
          this.snackbar.alertType = "error";
          this.snackbar.message = "Errore, impossibile avviare la simulazione";
          this.snackbar.alertColor = 'red';
          this.snackbar.showSnackbar = true;
        });


      } catch (error) {
        
      }
    },

    // getProssimaSimulazione() {
    //   axios
    //   .get('/ottieniProssimaSimulazione')
    //   .then(response => {
    //     return response.data.nextSimulazione;   
    //   })
    // },
    // goToSimulazione(idSimulazione, dataOraSimulazione) {
    //   // console.log(dataOraSimulazione);
    //   // return
    //   if(this.isEnteringSimulazione) return;

    //   this.isEnteringSimulazione = true;

    //   if(window.__IS_FIRST_ACCESS_SIMULAZIONE__ == '1'){
    //     axios
    //     .get("/cliccatore/accessedSimulazione") // Aggiorno valore nel DB: is_first_access_simulazione = false;
    //     .then(response => {
    //       axios
    //       .get("/cliccatore/accediSimulazione?guidata=true") // passo guidata=true in modo da non considerare la simulazione skippata
    //           // window.location.href = "simulazione/"+id+"?guida=true";
    //       .then(response => {
    //         this.salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione);
    //       })  
    //     })
    //     .catch(()=>{
    //       // Non rimettere la variabile a false se c'è un errore, tanto cambierà pagina
    //       this.isEnteringSimulazione = false;
    //     });
    //   } else {
    //     // Controllo se ho skippato simulazioni:
    //     axios
    //     .get(`/cliccatore/accediSimulazione/${idSimulazione}/${this.info.bandoId}/${dataOraSimulazione}`)
    //     .then(response => {
    //       this.salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione);
    //     })
    //     .catch(()=>{
    //       // Non rimettere la variabile a false se c'è un errore, tanto cambierà pagina
    //       this.isEnteringSimulazione = false;
    //     });
    //   }     
    // },

    // salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione) {
    //   axios
    //   .post('/salvaSimulazione', {
    //     id: idSimulazione,
    //     dataOra: dataOraSimulazione
    //   })
    //   .then(response => {
    //     if (response.data.hasError) {
    //       this.alertType = "error";
    //       this.message = response.data.message;
    //       this.alertColor = 'red';
    //       this.showSnackbar = true;

    //     } else {
    //       this.$router.push({ name: 'simulazione-route' });
    //     }
    //   })
    //   .catch(error => {
    //     this.alertType = "error";
    //     this.message = "Errore, impossibile avviare la simulazione";
    //     this.alertColor = 'red';
    //     this.showSnackbar = true;
    //   });
    // },
  },
  computed: {
    // computedIsProvaGratuita: function(){
    //   return this.$route.params.provaGratuita == true;
    // }
  }
};
</script>

<style scoped>
  #logo {font-size:24px;border:4px solid;border-color:#E6D566;background-color:#508EB1;color:#FFF;width:99%;font-family:Times,serif;text-align:center;margin-left:auto;margin-right:auto}
  .logo-strong {font:48px Times,serif}
</style>